import React, { useEffect, useState } from "react";
import Boardcard from "../../Components/Boardcard/Boardcard";
import ButtonPagenate from "../../Components/ButtonPagenate/ButtonPagenate";
import Navbar from "../../Components/Navbar/navbar";
import Topbarsub from "../../Components/Topbar/Topbarsub";
import "../Employee/employee.css";
import CountryList from "./countryList";
import { GrEdit } from "react-icons/gr";
import { AiFillDelete } from "react-icons/ai";
import { CountriesFilter } from "../ListFunction/listfunction";

const Country = ({ page, addnewoverlay, empselect }) => {
  const [searchcriteria, setSearchcriteria] = useState("");
  const [country, setCountry] = useState(empselect.allCountries);
  const [nameSearch, setNameSearch] = useState("");

  const [pageNumber, setPageNumber] = useState(0);
  //   const [loading, setLoading] = useState(true)
  //   const [ confirmresponse, setConfirmresponse] = useState(0)

  const itemsPerpage = 8; //Number of items to be displayed per page
  const pageCount = Math.ceil(country.length / itemsPerpage);
  const pagesVisited = pageNumber * itemsPerpage;

  // const totalCountry = country.length;
  //   const API = 'https://admin.sabrecwa.com/backend'

  const handleSearchCriteria = (incoming) => {
    setSearchcriteria(incoming);
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleAddNewEmp = () => {};

  const filterSearch = (incoming) => {
    setNameSearch(incoming.toString());
  };

  var EmployeeLists = country.filter((filteredItem) => {
    if (searchcriteria === "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch === "") {
      return filteredItem;
    } else if (searchcriteria === "" && nameSearch !== "") {
      return filteredItem;
    } else if (searchcriteria !== "" && nameSearch !== "") {
      if (searchcriteria === "Fullname") {
        if (
          filteredItem.firstname
            .toLowerCase()
            .includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else if (searchcriteria === "Country") {
        if (
          filteredItem.country.toLowerCase().includes(nameSearch.toLowerCase())
        ) {
          return filteredItem;
        }
      } else {
        return filteredItem;
      }
    }
  });

  const newPagenum = (num) => {
    setPageNumber(num);
  };

  const handleDelete = (incoming) => {
    console.log(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleEdit = (incoming) => {
    addnewoverlay(incoming);
    console.log(incoming);
    // Open performance appraisal page to fetch the record of user with the particular ID if it exists in the db
  };

  const handleaddOverlay = (incoming) => {
    addnewoverlay(incoming);
  };

  useEffect(() => {
    handleWidth();
  }, []);

  const [widthval, setWidthval] = useState({
    pie1: 0,
  });

  const handleWidth = () => {
    setWidthval({ pie1: country.length });
  };

  return (
    <div className="employee-container">
      <Navbar tabtext="Countries" currentab="others" />
      <Topbarsub
        serchCriteria={handleSearchCriteria}
        newEmployee={handleAddNewEmp}
        currrenTab={page}
        searchword={filterSearch}
        addoverlay={handleaddOverlay}
      />
      <div className="tretapp-card-container">
        <Boardcard
          val={widthval.pie1}
          name="Total Countries"
          maxV={15}
          minV={0}
        />
      </div>

      <div className="tretapp-list-submitted">
        <div className="tapp-list-title-container">
          <span id="tapp-list-title">Country Lists</span>
        </div>
        <div className="comp-list-table-containerr">
          <table>
            <thead>
              <tr>
                <th scope="col">#ID</th>
                <th scope="col">Country</th>
                <th scope="col">Country Head</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {EmployeeLists.slice(
                pagesVisited,
                pagesVisited + itemsPerpage
              ).map((items) => (
                <tr>
                  <td data-label="#ID">{items.ID}</td>
                  <td data-label="Country">{items.name}</td>
                  <td data-label="Country Head">
                    {CountriesFilter(empselect, items.country_head)}
                  </td>
                  <td data-label="Action">
                    <GrEdit
                      onClick={() =>
                        handleEdit({ tag: "newcountry", ID: items.id })
                      }
                      id="butn-action"
                    />
                    <AiFillDelete
                      onClick={() => handleDelete(items.id)}
                      id="butn-action"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="papp-table-pgnate-contain">
            <button
              id="addbitn"
              onClick={() => handleaddOverlay({ tag: "newcountry" })}
            >
              Add
            </button>
            <ButtonPagenate
              updatedPageNum={newPagenum}
              pageCount={pageCount}
              pageNumber={pageNumber}
              previousLabel="Prev"
              nextLabel="Next"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Country;
